import styles from "./DataState.module.css";
import emptyState from "../../../assets/icons/Empty State.png";
import { AddRegisterButton } from "../../../fixedassetelements/button/Button";

const DataState = ({ setShowAddRegisterModal }) => {

  return (
    <div className={styles.contentContainer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <img src={emptyState} alt="empty" />
          <p className={styles.message}>
            <span className={styles.topText}>Nothing here yet</span>
            <br />
            <span className={styles.bottomText}>
              Add a register to get started
            </span>
          </p>
          <div>
            <AddRegisterButton  onClick={() => setShowAddRegisterModal(true)} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataState;
